import ehlo from './ehlo'
import clearWebViewCache from './clear-web-view-cache'
import contactsSettingsPermissions from './contacts-settings-permissions'
import contactsList from './contacts-list'
import devTest from './dev-test'
import share from './share'
import shareDigitalFlyer from './share-digital-flyer'
import download from './download'
import pushToken from './push-token'
import analyticsEvent from './analytics-event'
import subscriptionPlans from './subscription-plans'
import subscriptionBuyAndroid from './subscription-buy-android'
import subscriptionOwnedAndroid from './subscription-owned-android'
import subscriptionBuyIos from './subscription-buy-ios'
import subscriptionRestoreIos from './subscription-restore-ios'
import subscriptionTransactionDoneIos from './subscription-transaction-done-ios'
import subscriptionRefreshReceiptIos from './subscription-refresh-receipt-ios'
import authLogin from './auth-login'
import authLogout from './auth-logout'
import supportOpen from './support-open'
import oauthApple from './oauth-apple'
import oauthFb from './oauth-fb'
import close from './close'
import locationRequest from './location-request'

import onboardingBusinessCreated from './onboarding-business-created'
import onboardingBusinessUpdated from './onboarding-business-updated'
import type { CustomEventsContext } from '../types'

export type { CustomEventsContext } from '../types'

/*
 * Argument `_this` contains:
 *  `sendEvent`
 *  `sendEventWithCallback`
 *  `ERROR_TIMEOUT`,
 *  `ERROR_UNKNOWN`
 * and becomes `this` in functions!
 */
export function makeCustomEvents (_this: CustomEventsContext): Record<string, (...args: unknown[]) => unknown> {
  return Object.entries({
    /*
     * put new custom events functions here
     */
    ehlo,
    clearWebViewCache,
    contactsSettingsPermissions,
    contactsList,
    devTest,
    share,
    shareDigitalFlyer,
    download,
    pushToken,
    analyticsEvent,
    subscriptionPlans,
    subscriptionBuyAndroid,
    subscriptionOwnedAndroid,
    subscriptionBuyIos,
    subscriptionRestoreIos,
    subscriptionTransactionDoneIos,
    subscriptionRefreshReceiptIos,
    authLogin,
    authLogout,
    supportOpen,
    oauthApple,
    oauthFb,
    close,
    locationRequest,
    onboardingBusinessCreated,
    onboardingBusinessUpdated,
  }).reduce<Record<string,(...args: unknown[]) => unknown>>((events, entry) => {
    const [name, fn] = entry as [string, (...args: unknown[]) => unknown]
    events[name] = fn.bind(_this)
    return events
  }, {})
}
